import { authFetch } from "lib/api/authFetch";
import { normalizeApiMessage } from "lib/i18n/apiMessage";
import { BACKEND_URL } from "lib/utils/baseUrl";

function triggerBlobDownload(blob, fileName) {
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.href = url;
  link.download = `${fileName}.hml`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

function getDownloadBaseName(value, fallback) {
  const raw = String(value || fallback || "electrical_safety_report").trim();
  const extIndex = raw.lastIndexOf(".");
  return extIndex > 0 ? raw.slice(0, extIndex) : raw;
}

export async function getElectricalSafetyHmlReport(uploadId, fileName) {
  if (!uploadId) {
    return {
      success: false,
      ...normalizeApiMessage(
        { message: "Invalid request. upload_id is missing." },
        "Invalid request. upload_id is missing.",
      ),
    };
  }

  try {
    const path = `${BACKEND_URL}/project/hml_electrical_safety_report/${uploadId}`;
    const res = await authFetch(
      path,
      {
        method: "GET",
      },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    if (!res.ok) {
      const fallback = `Failed to download electrical safety HML report (status: ${res.status})`;

      let parsed = null;
      try {
        parsed = await res.json();
      } catch {
        parsed = null;
      }

      const normalized = normalizeApiMessage(parsed, fallback);

      return {
        success: false,
        ...normalized,
        messageKey:
          normalized.messageKey ||
          (res.status === 401 ? "api.auth.token.expired" : ""),
      };
    }

    const blob = await res.blob();
    triggerBlobDownload(blob, getDownloadBaseName(fileName, uploadId));

    return {
      success: true,
      ...normalizeApiMessage(
        { message: "Electrical safety HML report downloaded successfully." },
        "Electrical safety HML report downloaded successfully.",
      ),
    };
  } catch (error) {
    console.error("Electrical safety HML report request failed:", error);
    return {
      success: false,
      ...normalizeApiMessage(
        {
          message:
            error?.message || "Electrical safety HML report request failed.",
        },
        error?.message || "Electrical safety HML report request failed.",
      ),
      messageKey: "api.common.networkError",
    };
  }
}
